module.exports = __webpack_public_path__ + "fonts/Quicksand-500-latin-ext8.29b81f3.woff2";